import { useContext, useEffect, useState } from "react";
import VonSettings from "../AllVon/VonSettings/VonSettings";
import { GlobalContext } from "../../context";
import { logoutHandler } from "../../context/actions/auth";
import { useNavigate } from "react-router-dom";
import { PiPowerBold } from "react-icons/pi";

export default function Settings() {
  const {
    authDispatch,
    authState: { loggedIn },
  } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const executeLogout = async () => {
    setShowLogoutModal(false);
    await logoutHandler(authDispatch);
    navigate("/");
  };

  useEffect(() => {
    if (loggedIn === false) {
      navigate("/sign-in");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  return (
    <div className="py-8 px-6 md:px-10 max-w-6xl mx-auto mb-10">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900">
            Profile Settings
          </h1>
          <p className="text-xs md:text-sm text-gray-400 mt-1">
            Manage your account details, password, and preferences
          </p>
        </div>

        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-4 py-2.5 bg-red-50 hover:bg-red-100 text-red-600 rounded-xl text-xs sm:text-sm font-semibold transition-all shadow-sm active:scale-95 cursor-pointer"
        >
          <PiPowerBold size={16} />
          Logout
        </button>
      </div>

      <div className="border-b border-gray-100 mb-8" />

      <VonSettings />

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-xl border border-gray-100">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 rounded-full bg-red-50 text-red-500 flex items-center justify-center mb-4">
                <PiPowerBold size={24} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Confirm Logout</h3>
              <p className="text-sm text-gray-500 mb-6">
                Are you sure you want to log out of your learning dashboard?
              </p>
              <div className="flex gap-3 w-full">
                <button
                  onClick={() => setShowLogoutModal(false)}
                  className="flex-1 py-3 px-4 rounded-xl border border-gray-200 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={executeLogout}
                  className="flex-1 py-3 px-4 rounded-xl bg-red-500 text-white text-sm font-semibold hover:bg-red-600 shadow-sm shadow-red-200 transition-colors"
                >
                  Log Out
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
